import React, { useEffect, useState } from 'react';
import { Section } from '@zurich-base-ui/layout.section';
import { StarRating } from '@zurich-zurichat/star-rating';
import { Button } from '@zurich-primitives/button';
import { sendFeedback } from 'integration';
import { IFeedback } from 'app/utils';
import { setFeedbackConfirmation, useAppDispatch } from 'app/redux';
import styles from './FeedbackView.module.scss';
import { FeedbackConfirmation } from 'app/components';

export const FeedbackView: React.FC = () => {
  const dispatch = useAppDispatch();
  const [rating, setRating] = useState<number | undefined>();
  const [comments, setComments] = useState<string | undefined>();

  useEffect(() => {
    clearFeedbackForm();
  }, []);

  const clearFeedbackForm = (): void => {
    setRating(0);
    setComments('');
  };

  const handleSubmit = (): void => {
    const feedback: IFeedback = {
      origin: 'give-us-feedback',
      rating,
      feedback: comments ?? ''
    };
    sendFeedback(feedback)
      .then((response) => {
        response !== undefined && dispatch(setFeedbackConfirmation(true));
      })
      .finally(() => {
        clearFeedbackForm();
      });
  };

  return (
    <Section className={styles.section}>
      <h2 className="highlight">Give us Feedback</h2>
      <p className={`body-sm-r`}>
        To help us get better, please rate GenAI Business Services
      </p>
      <StarRating
        onRating={(e) => setRating(e)}
        className={styles.stars}
        controlled
        rating={rating}
      />
      <textarea
        placeholder="Enter your comment here"
        className={styles['text-area']}
        spellCheck="false"
        onChange={(e) => setComments(e.target.value)}
        value={comments}
      />
      <div className={`${styles.modalButtons}`}>
        <Button onClick={handleSubmit} disabled={!comments || comments === ''}>
          Submit
        </Button>
      </div>
      <FeedbackConfirmation />
    </Section>
  );
};

export default FeedbackView;
